import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { timeEntryCollection } from './time-entry-collection';
export const attachTimeEntryTabSync = ()=>attachTabSync({
        collection: timeEntryCollection,
        sync: getTabSync()
    });
